<template>
  <div >
    <div class="loading-area">
    <v-btn
      class="loading-button"
      fab
      :loading="loading"
      v-if="loading"
      elevation= "2"
    ></v-btn>
    </div>
    <v-card
      class="mx-auto"
      max-width="1440"
      outlined
      elevation="0"
      v-if="!loading"
    >
      <card-header :diaryType="'menu'" @studentsLoaded="reloadStudents"></card-header>
      <menu-diary class="height-area" :classId="classId" :students="students" @updatedStudent="catchChanges"/>
    </v-card>
  </div>
</template>

<script>
import { DIARY_DATA, UPDATE_MENU_DIARY } from '@/store/actions/user'
import MenuDiary from '../components/diaryType/MenuDiary/index.vue'
import CardHeader from '../components/Elements/CardHeader.vue'

export default {
  components: { MenuDiary, CardHeader },
  // computed: mapState({ studentsDiary: state => state.user.profile }),
  created () {
    this.classId = this.$route.params.classId.toString() || ''
    this.loading = true
    this.$store.dispatch(DIARY_DATA, this.classId).then((data) => {
      this.students = data.menu
      this.loading = false
    }, (error) => { // Failure
      console.log('Error en Formulario Agenda')
      console.log({error})
    })
  },
  data: () => ({
    classId: '',
    students: undefined,
    selectedItem: 1,
    selectedClass: undefined,
    loading: false
  }),
  methods: {
    showClassroom: function (classId) {
      this.$router.go(-1)
    },
    reloadStudents: function (students) {
      this.students = students.menu
    },
    catchChanges: function (newVersion) {
      // console.log({newVersion})
      this.$store.dispatch(UPDATE_MENU_DIARY, {classId: this.classId, menuData: newVersion}).then((data) => {
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/menuForm.vue